export function obterVersao(): string {
    return 'v1.8.0';
}

export function obterNomeEmpresa(): string {
    return 'Naja Soluções';
}

export function formatarPorTipoPersonalizado(type: string, value: string): string {
    if (type) {
        switch (type) {
            case 'tipoControle':
                return formatarTipoControle(value);
            case 'operador':
                return formatarOperador(value);
            default:
                return value;
        }
    } else {
        return value;
    }
}

export function verificarOrdemPorTipoPersonalizado(ordem: string, type: string, a: string, b: string): number {
    if (type) {
        switch (type) {
            case 'tipoControle':
                return verificarOrdemTipoControle(ordem, a, b);
            case 'operador':
                return verificarOrdemOperador(ordem, a, b);
            default:
                return 0;
        }
    } else {
        return 0;
    }
}

function verificarOrdemTipoControle(ordem: string, campoA: string, campoB: string): number {
    let a: number = formatarTipoControleOrdem(campoA);
    let b: number = formatarTipoControleOrdem(campoB);

    if (ordem === 'asc') {
        if (a > b) {
            return 1;
        }
        if (a < b) {
            return -1;
        }
        return 0;
    } else if (ordem === 'desc') {
        if (a < b) {
            return 1;
        }
        if (a > b) {
            return -1;
        }
        return 0;
    } else {
        return 0;
    }
}

function formatarTipoControleOrdem(value: string): number {
    return parseInt(value);
}

export function formatarTipoControle(tipoControle: string): string {
    switch (parseInt(tipoControle)) {
        case 1:
            return 'Valor';
        case 2:
            return 'Flag';
        case 3:
            return 'Personalizado';
        default:
            return '';
    }
}

function verificarOrdemOperador(ordem: string, campoA: string, campoB: string): number {
    let a: number = formatarOperadorOrdem(campoA);
    let b: number = formatarOperadorOrdem(campoB);

    if (ordem === 'asc') {
        if (a > b) {
            return 1;
        }
        if (a < b) {
            return -1;
        }
        return 0;
    } else if (ordem === 'desc') {
        if (a < b) {
            return 1;
        }
        if (a > b) {
            return -1;
        }
        return 0;
    } else {
        return 0;
    }
}

function formatarOperadorOrdem(value: string): number {
    return parseInt(value);
}

export function formatarOperador(tipoControle: string): string {
    switch (parseInt(tipoControle)) {
        case 0:
            return 'Qualquer um';
        case 1:
            return '=';
        case 2:
            return '>';
        case 3:
            return '<';
        default:
            return '';
    }
}